import React, { useState, useEffect, useCallback, useRef } from 'react';
import Logo from "../images/logo.svg";
import Sidebar from '../component/Sidebar';
import { SelectPicker, Button, Placeholder, DatePicker, Whisper, Tooltip } from 'rsuite';
import "rsuite/DatePicker/styles/index.css";
import 'rsuite/SelectPicker/styles/index.css';
import IconExcel from "../images/icon-excel.svg";
import IconEFTToggle from "../images/btn_eft_toggle.svg";
import 'aos/dist/aos.css';
import AOS from 'aos';
import imgBack from "../images/icon-back.svg";
import { useParams, Link, useNavigate } from "react-router-dom";
import debounce from 'lodash.debounce';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import moment from 'moment';
import moment1 from 'moment-timezone';
import IconReset from "../images/IconReset.svg";


function ETFHolding() {
  const timeZone = 'Asia/Kolkata';
  const [tabName, setTabName] = useState('ETF Purification Holding');
  const { company_symbol } = useParams();
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);



  const toast = useToast()
  const toastIdRef = React.useRef()

  const navigate = useNavigate();
  const userid = localStorage.getItem("novauserid");

  const [etfName, setEtfName] = useState("");
  const [isLoading, setLoading] = useState(true); // State to manage loading state
  const abortControllerRef = useRef(null);
  const apiEndPoint = process.env.REACT_APP_ETF_API_ENDPOINT;
  const [pageRange, setPageRange] = useState("20");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");

  const [topTableHeader, setTopTableHeader] = useState([]);
  const [topTableUnitFinnhub, setTopTableUnitFinnhub] = useState([]);
  const [topTableUnitManual, setTopTableUnitManual] = useState([]);
  
  // Revenue and Holdings data
  const [topTableTotalRevenue, setTopTableTotalRevenue] = useState([]);
  const [topTableCompliantRevenue, setTopTableCompliantRevenue] = useState([]);
  const [topTableNonCompliantRevenue, setTopTableNonCompliantRevenue] = useState([]);
  const [topTableDoubtfulRevenue, setTopTableDoubtfulRevenue] = useState([]);
  const [topTableTotalHoldings, setTopTableTotalHoldings] = useState([]);

  const [tableHeader, setTableHeader] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [etfData, setETFData] = useState([]);

  const [tableFooter1, setTableFooter1] = useState([]);
  const [tableFooter2, setTableFooter2] = useState([]);
  const [tableFooter3, setTableFooter3] = useState([]);
  // TOGGLE SHOW HIDE
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [customPaginationValue, setCustomPaginationValue] = useState("");


  const scrollContainerRef = useRef(null);
  const [isColoumLoading, setIsColoumLoading] = useState(false);
  const [dateOffset, setDateOffset] = useState(0); // used in API call to get next columns

  const [interestRate, setInterestRate] = useState("");
  const [manualUnits, setManualUnits] = useState("");
  const [calculateIRLoading, setCalculateIRLoading] = useState(false);
  const [calculateUnitLoading, setCalculateUnitLoading] = useState(false);
  const [calculateUnitLoading1, setCalculateUnitLoading1] = useState(false);

  const [unitUpdatedFlag, setUnitUpdatedFlag] = useState(false);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [days, setDays] = useState(30);

  // TABLE SCROLLABLE
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  const handleScroll = async (source) => {
    console.log(tableHeader.length);
    // Updated to trigger loading at 30 columns instead of 24
    if (tableHeader.length < 30) return;

    const other = source === "table1" ? bottomRef.current : topRef.current;
    const current = source === "table1" ? topRef.current : bottomRef.current;

    if (other && current) {
      other.scrollTop = current.scrollTop;
      other.scrollLeft = current.scrollLeft;

      // Check if user has scrolled to the end horizontally with a small buffer
      const isAtEnd = current.scrollLeft + current.clientWidth >= current.scrollWidth - 50;

      if (!isAtEnd) return; // Stop if not at end
    }

    // Store current scroll position before loading
    const currentScrollLeft = current?.scrollLeft || 0;
    const currentScrollTop = current?.scrollTop || 0;

    setIsColoumLoading(true);

    const newOffset = dateOffset + 1;

    try {
      const controller = new AbortController();
      abortControllerRef.current = controller;

      const apiUrl = `${apiEndPoint}/etf_purification_holding`;
      const requestData = {
        data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          q: searchInput,
          symbol: company_symbol,
          date_offset: newOffset,
          days:days,
        }
      };

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
        signal: controller.signal
      });

      const jsonData = await response.json();
      const newData = jsonData.data;

      if (newData.status === 'success') {
        // Update data with smooth transition
        setTopTableHeader((prev) => [...prev, ...newData.tables.units_table.header.slice(1)]);
        setTopTableUnitFinnhub((prev) => [...prev, ...newData.tables.units_table.rows.Units_finnhub.slice(1)]);
        setTopTableUnitManual((prev) => [...prev, ...newData.tables.units_table.rows.Units_manual.slice(1)]);
        
        // Load revenue and holdings data dynamically
        if (newData.tables.units_table.rows.Total_revenue) {
          setTopTableTotalRevenue((prev) => [...prev, ...newData.tables.units_table.rows.Total_revenue.slice(1)]);
        }
        if (newData.tables.units_table.rows.Compliant_revenue) {
          setTopTableCompliantRevenue((prev) => [...prev, ...newData.tables.units_table.rows.Compliant_revenue.slice(1)]);
        }
        if (newData.tables.units_table.rows.Non_compliant_revenue) {
          setTopTableNonCompliantRevenue((prev) => [...prev, ...newData.tables.units_table.rows.Non_compliant_revenue.slice(1)]);
        }
        if (newData.tables.units_table.rows.Doubtful_revenue) {
          setTopTableDoubtfulRevenue((prev) => [...prev, ...newData.tables.units_table.rows.Doubtful_revenue.slice(1)]);
        }
        if (newData.tables.units_table.rows.Total_holdings) {
          setTopTableTotalHoldings((prev) => [...prev, ...newData.tables.units_table.rows.Total_holdings.slice(1)]);
        }

        // append new column data to the right
        setTableHeader((prev) => [...prev, ...newData.tables.main_table.table_header.slice(2)]);
        setTableData((prev) =>
          prev.map((row, index) => ({
            ...row,
            share: [...row.share, ...(newData.tables.main_table.table_data[index]?.share?.slice(2) || [])],
            purification_amount_etf: [...row.purification_amount_etf, ...(newData.tables.main_table.table_data[index]?.purification_amount_etf?.slice(2) || [])],
            atDate: row.atDate ? [...row.atDate, ...(newData.tables.main_table.table_data[index]?.atDate?.slice(2) || [])] : (newData.tables.main_table.table_data[index]?.atDate?.slice(2) || [])
          }))
        );
        setTableFooter1((prev) => [...prev, ...newData.table_footer.total_purification_per_day.slice(1)]);
        setTableFooter2((prev) => [...prev, ...newData.table_footer.purification_per_unit_per_day.slice(1)]);
        setTableFooter3((prev) => [...prev, ...newData.table_footer.purification_ratio.slice(1)]);
        setDateOffset(newOffset);
        
        // Maintain scroll position after data loads
        setTimeout(() => {
          if (current) {
            current.scrollLeft = currentScrollLeft;
            current.scrollTop = currentScrollTop;
          }
          if (other) {
            other.scrollLeft = currentScrollLeft;
            other.scrollTop = currentScrollTop;
          }
        }, 100);
        
        setIsColoumLoading(false);
      }
      else if (newData.status === 'error') {
        setIsColoumLoading(false);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        toastIdRef.current = toast({ description: error.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        setIsColoumLoading(false);
      }
    }
  };

  // Handle scroll synchronization between top and bottom tables
  const handleTableScroll = (source) => {
    const topContainer = topRef.current;
    const bottomContainer = bottomRef.current;

    if (!topContainer || !bottomContainer) return;

    const current = source === "top" ? topContainer : bottomContainer;
    const other = source === "top" ? bottomContainer : topContainer;

    // Synchronize horizontal scroll
    other.scrollLeft = current.scrollLeft;
    
    // Also call the original handleScroll for loading more columns
    handleScroll(source === "top" ? "table1" : "table2");
  };

  // useEffect(() => {
  //   const topContainer = topRef.current;
  //   const bottomContainer = bottomRef.current;

  //   if (topContainer) {
  //     topContainer.addEventListener('scroll', handleScroll);
  //   }

  //   if (bottomContainer) {
  //     bottomContainer.addEventListener('scroll', handleScroll);
  //   }

  //   return () => {
  //     if (topContainer) {
  //       topContainer.removeEventListener('scroll', handleScroll);
  //     }

  //     if (bottomContainer) {
  //       bottomContainer.removeEventListener('scroll', handleScroll);
  //     }
  //   };
  // }, [handleScroll]);



  const toggleContent = () => {
    setIsContentVisible(prevState => !prevState);
  };

  useEffect(() => {
    AOS.init();
  }, []);

  const [activeTab, setActiveTab] = useState('PurificationAmount');


  const handleBack = async () => {
    navigate("/ETFPurification");
  };


  const fetchGlobalReport = async () => {
    setLoading(true);
    // Cancel the previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController for the current request
    const controller = new AbortController();
    abortControllerRef.current = controller;


    try {
      const apiUrl = `${apiEndPoint}/etf_purification_holding`;
      const requestData = {
        data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          q: searchInput,
          symbol: company_symbol,
          date_offset: 0,
          days:days,

        }
      };
      console.log(JSON.stringify(requestData));
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData),
        signal: controller.signal
      });

      const jsonData = await response.json();
      const data = jsonData.data;
      //const { status, message, count, data, ETF_Data,total_Revenue,total_Revenue_currency,Etf_Name,Calculation_Type } = jsonData.data;
      if (data.status == "success") {
        setLoading(false);
        setReportCount(data.count);

        //TOP Header
        setTopTableHeader(data.tables.units_table.header);
        setTopTableUnitFinnhub(data.tables.units_table.rows.Units_finnhub);
        setTopTableUnitManual(data.tables.units_table.rows.Units_manual);
        
        // Load initial revenue and holdings data
        if (data.tables.units_table.rows.Total_revenue) {
          setTopTableTotalRevenue(data.tables.units_table.rows.Total_revenue);
        }
        if (data.tables.units_table.rows.Compliant_revenue) {
          setTopTableCompliantRevenue(data.tables.units_table.rows.Compliant_revenue);
        }
        if (data.tables.units_table.rows.Non_compliant_revenue) {
          setTopTableNonCompliantRevenue(data.tables.units_table.rows.Non_compliant_revenue);
        }
        if (data.tables.units_table.rows.Doubtful_revenue) {
          setTopTableDoubtfulRevenue(data.tables.units_table.rows.Doubtful_revenue);
        }
        if (data.tables.units_table.rows.Total_holdings) {
          setTopTableTotalHoldings(data.tables.units_table.rows.Total_holdings);
        }

        setTableHeader(data.tables.main_table.table_header);
        setTableData(data.tables.main_table.table_data);
        setEtfName(data.etf_name);
        setETFData(data);
        setInterestRate(data.purification_interest_rate);
        setManualUnits(data.etf_totalunits_manual)
        setTableFooter1(data.table_footer.total_purification_per_day);
        setTableFooter2(data.table_footer.purification_per_unit_per_day);
        setTableFooter3(data.table_footer.purification_ratio);
      } else {
        console.error("Error: ", data.message);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request cancelled");
      }
      else {
        console.error("Error fetching data:", error.message);
      }
      return false;
    }
  };

  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 500),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    setExpandedRowId(null);
    fetchGlobalReport();
  }, [currentPage, pageRange, unitUpdatedFlag]); // Regular effect for other dependencies


  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;

    } else {

      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav aria-label="..." id='pagination_row' style={{ alignItems: 'center', justifyContent: 'space-between', background: '#FFF', paddingTop: 0, paddingBottom: 0, zIndex: 10 }}>
        <div className='totalRecords'>
          Total Records :  {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: 'none' }}>

          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker onChange={handlePagelimit} cleanable={false}
              value={pageRange}
              placement="top" placeholder='Pages' data={PagingData} searchable={false} style={{ width: 85, height: 35, display: 'flex', alignItems: 'center', borderRadius: 5, border: '1px solid #A1B9ED' }} />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`} style={{ marginLeft: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map(page => (
            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
              <a
                className="page-link" href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`} style={{ marginRight: 10 }}>
            <a href="#" className="page-link" onClick={() => setCurrentPage(totalPages)}>
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li className="page-item" style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}

              style={{
                padding: '0px 10px',
                color: '#878787',
                fontSize: 16,
                borderRadius: 5,
                border: '1px solid #A1B9ED',
                width: 60,
                height: 35,
                textAlign: 'center'
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };

  const PagingData = ['10', '20', '50', '100'].map(
    item => ({ label: item, value: item })
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 500), // Delay of 500ms (half a second)
    []
  );


  const [expandedRowId, setExpandedRowId] = useState(null);

  // const handleRowClick = (id) => {
  //   console.log(expandedRowId + ' : ' + id);
  //   if (expandedRowId == id) {
  //     setExpandedRowId(null);
  //   }
  //   else {
  //     setExpandedRowId(id);

  //   }

  // };
const [rowHistoryData, setRowHistoryData] = useState({});
const [loadingRowId, setLoadingRowId] = useState(null); // optional: for loader

  const handleRowClick = async (index) => {
  if (expandedRowId === index) {
    setExpandedRowId(null);
    return;
  }

 
 const row = tableData[index];
  const symbol = row.purification_amount_etf?.[0];
  const name = row.purification_amount_etf?.[1];

  // Show loading (optional)
  setLoadingRowId(index);
  try {
    const response = await fetch(`${apiEndPoint}/get_company_history`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          user_id: userid,
          symbol:symbol,
          name:name,
        }
      })
    });

    const result = await response.json();

    if (result.data?.status === 'success') {
      setRowHistoryData(prev => ({
        ...prev,
        [index]: result.data.history // store by row index
      }));
    } else {
      console.error(result.data?.message);
    }
  } catch (err) {
    console.error('API error:', err);
  }

  setExpandedRowId(index);
  setLoadingRowId(null); // end loading
};



  const handleSearch = (event) => {

    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const [aumFlag, setAumFlag] = useState(null);

  useEffect(() => {
    setAumFlag(etfData.etf_totalunits_flag);
  }, [etfData]);

  const handleCalculateIRConfirm = () => {

    setCalculateIRLoading(true);

    const url = `${apiEndPoint}/update_purification_interest_rate`;
    const payload = {
      data: {
        user_id: userid,
        symbol: company_symbol,
        interest_rate: interestRate,
        domicile: etfData.domicile,
      },
    };


    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())  // Parse the JSON response
      .then((data) => {
        const status = data?.data?.status;
        const message = data?.data?.message;

        if (status === "success") {
          toastIdRef.current = toast({ description: message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
          const cancelButton = document.getElementById(`CancelConfirmation`);
          if (cancelButton) {
            cancelButton.click();
          }

        } else {
          console.error('Calculation failed:', data);
          toastIdRef.current = toast({ description: message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
        setCalculateIRLoading(false);  // Stop loading after success
      })
      .catch((error) => {
        console.error('Manual Calculation Error:', error);
        toastIdRef.current = toast({ description: error, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        setCalculateIRLoading(false);  // Stop loading in case of error
      });
  };

  const handleIRCancel = () => {
    setCalculateIRLoading(false);
    const cancelButton = document.getElementById(`CancelConfirmation`);
    if (cancelButton) {
      cancelButton.click();
    }
  };


  const handleCalculateUnitConfirm = () => {

 

    let hasError = false;
    if (!fromDate) {
      toastIdRef.current = toast({ description: 'Please Select From Date', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
      hasError = true;
    }
    // if (!toDate) {
    //   toastIdRef.current = toast({ description: 'Please Select To Date', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
    //   hasError = true;
    // }

    if (!manualUnits) {
      toastIdRef.current = toast({ description: 'Please Add Unit', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
      hasError = true;
    }


    
 if (!hasError) {
  setCalculateUnitLoading(true);


    const url = `${apiEndPoint}/update_etf_total_units`;
    const payload = {
      data: {
        user_id: userid,
        symbol: company_symbol,
        total_unit: manualUnits,
        total_unit_flag: 1,
        date_from:moment1(fromDate).tz(timeZone).format(),
        date_to:moment1(toDate).isValid() ? moment(toDate).tz(timeZone).format() : '',
      },
    };


    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())  // Parse the JSON response
      .then((data) => {
        const status = data?.data?.status;
        const message = data?.data?.message;

        if (status === "success") {
          setUnitUpdatedFlag(prev => !prev);
          setManualUnits("");
          toastIdRef.current = toast({ description: message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
          const cancelButton = document.getElementById(`CancelUnitConfirmation`);
          setFromDate(null);
          setToDate(null);
          if (cancelButton) {
            cancelButton.click();
          }
        } else {
          console.error('Calculation failed:', data);
          toastIdRef.current = toast({ description: message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
        setCalculateUnitLoading(false);  // Stop loading after success
      })
      .catch((error) => {
        console.error('Manual Calculation Error:', error);
        toastIdRef.current = toast({ description: error, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        setCalculateUnitLoading(false);  // Stop loading in case of error
      });
    }
  };

  const handleUnitsCancel = () => {
    setCalculateUnitLoading(false);
    const cancelButton = document.getElementById(`CancelUnitConfirmation`);
    if (cancelButton) {
      cancelButton.click();
    }
  };

  const handleCalculateUnitConfirm1 = () => {

    let hasError = false;
    if (!fromDate) {
      toastIdRef.current = toast({ description: 'Please Select From Date', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
      hasError = true;
    }
    if (!toDate) {
      toastIdRef.current = toast({ description: 'Please Select To Date', status: 'error', duration: 5000, isClosable: true, position: 'bottom-left', });
      hasError = true;
    }
    
  
  if (!hasError) {
    setCalculateUnitLoading1(true);
      const url = `${apiEndPoint}/update_etf_total_units`;
      const payload = {
        data: {
          user_id: userid,
          symbol: company_symbol,
          total_unit_flag: 0,
          date_from:moment1(fromDate).tz(timeZone).format(),
          date_to:moment1(toDate).tz(timeZone).format(),
        },
    };


    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())  // Parse the JSON response
      .then((data) => {
        const status = data?.data?.status;
        const message = data?.data?.message;

        if (status === "success") {
          setUnitUpdatedFlag(prev => !prev);
          setManualUnits("");
          toastIdRef.current = toast({ description: message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
          const cancelButton = document.getElementById(`CancelUnitConfirmation1`);
          setFromDate(null);
          setToDate(null);
          if (cancelButton) {
            cancelButton.click();
          }
        } else {
          console.error('Calculation failed:', data);
          toastIdRef.current = toast({ description: message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        }
        setCalculateUnitLoading1(false);  // Stop loading after success
      })
      .catch((error) => {
        console.error('Manual Calculation Error:', error);
        toastIdRef.current = toast({ description: error, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        setCalculateUnitLoading1(false);  // Stop loading in case of error
      });
    }
  };

  const handleUnitsCancel1 = () => {
    setCalculateUnitLoading1(false);
    const cancelButton = document.getElementById(`CancelUnitConfirmation1`);
    if (cancelButton) {
      cancelButton.click();
    }
  };

  // DATEPICKER
  const [date, setDate] = useState(new Date());
  function CustomCaretIcon() {
    return <i className="icon-calendar"></i>;
  }


  return (
    <>
      <style>
        {`
          @keyframes loading-shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
          
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <Sidebar />

      <div id='header'>
        <div className='logo'>
          <Button className='btn_Back_head' onClick={handleBack}><img src={imgBack} /></Button>
          <div className='logo_icon'>
            <img src={Logo} />
          </div>
          <div className='brand_name'>{etfName ? `${etfName}` : ''}</div>
        </div>

        <div className='header_table_filter' style={{ width: "auto" }}>
          <div className='searchfield' style={{ maxWidth: 320, width: 320 }}>
            <button className='btn_search'><i className='icon-search'></i></button>
            <input type='text' className='filter_searchfield' placeholder='Search by Symbol' onChange={handleSearch} value={searchInput} />
          </div>
        </div>
      </div>

      <div className="container-fluid content pb-5">
        <div id="etf_toggle_row" data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
          <div className='etf_head_row'>
            <ul>
              <li className='stock_lable'>{company_symbol}</li>
              <li className={`tag_td ${etfData.etf_shariah_status == "" || etfData.etf_shariah_status == null ? '' : etfData.etf_shariah_status == "CMPT" ? 'halal_tag' : etfData.etf_shariah_status == "NCMPT" ? 'not_halal_tag' : etfData.etf_shariah_status == "DBTF" ? 'doughtful_tag' : etfData.etf_shariah_status == "UCVD" ? 'uncover_tag' : ''}`} style={{ margin: 'auto' }}>{etfData.etf_shariah_status}</li>
            </ul>

            <div className='etf_right_controls'>
              <fieldset className='fieldset_col'>
                <legend className='legend_title'>ETF Details</legend>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10, }}>
                  <div className='input__group'>
                    <div className='input__group_redis_label_button'>
                      <div class="form_check__2">
                        <label class="form-check-label">
                          Interest Rate
                        </label>
                      </div>
                    </div>
                    <div className='input__group_redis_value_input'>
                      <input type="text" placeholder='0.00' className='aum_input' style={{ textAlign: 'right', width: 80 }} defaultValue={etfData.purification_interest_rate} value={interestRate} onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setInterestRate(value);
                        }
                      }} />
                      <button type='button' className='btn__save_aum' data-bs-toggle="modal" data-bs-target="#ModalDelete">Save</button>
                    </div>
                  </div>
                  
                  
                  <div className='input__group'>
                    <div className='input__group_label'>
                      Currency <span>(Maj.)</span>
                    </div>
                    <div className='input__group_value'>
                      (USD)
                    </div>
                  </div>
                </div>
              </fieldset>

              <fieldset className='fieldset_col'>
                <legend className='legend_title'>Unit Outstanding <small>(Manual)</small></legend>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10, }}>
                  <div className='input__group'>
                    <div className='input__group_label'>
                      From
                    </div>
                    <div className='input__group_value' style={{ paddingLeft: 0, paddingRight: 0 }}>
                      <div className="date_col_text calendar_col">
                        <DatePicker
                          oneTap
                          style={{ width: 120 }}
                          placeholder="Select Date"
                          caretAs={CustomCaretIcon}
                          disabledDate={(date) => date > moment().endOf('day')} // Disables future dates
                          value={fromDate}
                          onChange={(date) => setFromDate(date)}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ fontWeight: 500 }}>-</div>
                  <div className='input__group'>
                    <div className='input__group_label'>
                      To
                    </div>
                    <div className='input__group_value' style={{ paddingLeft: 0, paddingRight: 0 }}>
                      <div className="date_col_text calendar_col">
                        <DatePicker
                          oneTap
                          style={{ width: 120 }}
                          placeholder="Select Date"
                          caretAs={CustomCaretIcon}
                          disabledDate={(date) => date > moment().endOf('day')} // Disables future dates
                          value={toDate}
                          onChange={(date) => setToDate(date)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='input__group'>
                    <div className='input__group_redis_label_button'>
                      <div class="form_check__2">
                        <label class="form-check-label">
                          Unit
                        </label>
                      </div>
                    </div>
                    <div className='input__group_redis_value_input'>
                      <input type="text" placeholder={'0.00'} className='aum_input' style={{ textAlign: 'right', width: 80 }} defaultValue={etfData.etf_totalunits_manual} value={manualUnits} onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setManualUnits(value);
                        }
                      }} />

                      <Button className='btn_purification_save' data-bs-toggle="modal" data-bs-target="#ModalUpdateAUM1">Save</Button>
                    </div>
                  </div>
                  <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Reset</Tooltip>}>
                                    <Button type='button' className='btn__reset__etf' data-bs-toggle="modal" data-bs-target="#ModalUpdateAUM2"><img src={IconReset} /></Button>
                   </Whisper>

                </div>
              </fieldset>
            </div>
          </div>
          <div className={`etf_content_row_outer_wrap table__purification_outer_wrap ${isContentVisible ? 'open' : ''}`}>
            <div className=' etf_content_row_outer table__purification'>
              <div className='table-responsive' ref={topRef} onScroll={() => handleTableScroll("top")}>
                <table className='table table_fixed_column '>

                  <thead>
                    <tr className="table_tr_odd">
                      {topTableHeader.length > 0 &&
                        topTableHeader.map((item, index) => (
                          <>
                            <th className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''} style={{ textAlign: index == 0 ? 'left' : 'right', width: index === 0 ? '14%' : 'auto' }} width={index === 0 ? '280' : '220'}
                            >
                              <div className={index === 0 ? 'head_purification_col1' : ''}>
                                {item?.toString().trim() ? item : '\u00A0'}
                              </div>
                            </th>
                          </>
                        ))}
                      {isColoumLoading && (
                        <th style={{ 
                          minWidth: 120, 
                          background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                          backgroundSize: '200% 100%',
                          animation: 'loading-shimmer 1.5s infinite',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px',
                            color: '#666',
                            fontSize: '12px',
                            fontWeight: '500'
                          }}>
                            <div style={{
                              width: '16px',
                              height: '16px',
                              border: '2px solid #e0e0e0',
                              borderTop: '2px solid #007bff',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite',
                              marginRight: '8px'
                            }}></div>
                            Loading...
                          </div>
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="table_tr_even">
                      {topTableUnitFinnhub.length > 0 &&
                        topTableUnitFinnhub.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}

                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {(index === 0) ? (
                                <>
                                  Unit Outstanding <span>({item})</span>
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item === null || item === '0.00' ? 'date_null' : ''}> {item === null || item === '0.00' ? 'NULL' : item}</span>
                              )}
                            </div>
                          </td>
                        ))
                      }

                      {isColoumLoading && (
                        <td style={{ 
                          minWidth: 120,
                          background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                          backgroundSize: '200% 100%',
                          animation: 'loading-shimmer 1.5s infinite',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px',
                            color: '#666',
                            fontSize: '12px'
                          }}>
                            <div style={{
                              width: '12px',
                              height: '12px',
                              border: '2px solid #e0e0e0',
                              borderTop: '2px solid #007bff',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite',
                              marginRight: '6px'
                            }}></div>
                            Loading...
                          </div>
                        </td>
                      )}
                    </tr>

                    <tr className="table_tr_odd">
                      {topTableUnitManual.length > 0 &&
                        topTableUnitManual.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : index === 1 ? 'table__td_input_row_td' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}

                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {index === 0 ? (
                                <>
                                  Unit Outstanding <span>({item})</span>
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span>

                              )}
                            </div>
                          </td>
                        ))
                      }

                      {isColoumLoading && (
                        <td style={{ 
                          minWidth: 120,
                          background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                          backgroundSize: '200% 100%',
                          animation: 'loading-shimmer 1.5s infinite',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px',
                            color: '#666',
                            fontSize: '12px'
                          }}>
                            <div style={{
                              width: '12px',
                              height: '12px',
                              border: '2px solid #e0e0e0',
                              borderTop: '2px solid #007bff',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite',
                              marginRight: '6px'
                            }}></div>
                            Loading...
                          </div>
                        </td>
                      )}
                    </tr>

                    {/* Total Revenue Row */}
                    {topTableTotalRevenue.length > 0 && (
                      <tr className="table_tr_even">
                        {topTableTotalRevenue.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}
                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {index === 0 ? (
                                <>
                                  Total Revenue 
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span>
                              )}
                            </div>
                          </td>
                        ))}
                        {isColoumLoading && (
                          <td style={{ 
                            minWidth: 120,
                            background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'loading-shimmer 1.5s infinite',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}>
                              <div style={{
                                width: '12px',
                                height: '12px',
                                border: '2px solid #e0e0e0',
                                borderTop: '2px solid #007bff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '6px'
                              }}></div>
                              Loading...
                            </div>
                          </td>
                        )}
                      </tr>
                    )}

                    {/* Compliant Revenue Row */}
                    {topTableCompliantRevenue.length > 0 && (
                      <tr className="table_tr_odd">
                        {topTableCompliantRevenue.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}
                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {index === 0 ? (
                                <>
                                  Compliant Revenue 
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span>
                              )}
                            </div>
                          </td>
                        ))}
                        {isColoumLoading && (
                          <td style={{ 
                            minWidth: 120,
                            background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'loading-shimmer 1.5s infinite',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}>
                              <div style={{
                                width: '12px',
                                height: '12px',
                                border: '2px solid #e0e0e0',
                                borderTop: '2px solid #007bff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '6px'
                              }}></div>
                              Loading...
                            </div>
                          </td>
                        )}
                      </tr>
                    )}

                    {/* Non-Compliant Revenue Row */}
                    {topTableNonCompliantRevenue.length > 0 && (
                      <tr className="table_tr_even">
                        {topTableNonCompliantRevenue.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}
                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {index === 0 ? (
                                <>
                                  Non-Compliant Revenue
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span>
                              )}
                            </div>
                          </td>
                        ))}
                        {isColoumLoading && (
                          <td style={{ 
                            minWidth: 120,
                            background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'loading-shimmer 1.5s infinite',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}>
                              <div style={{
                                width: '12px',
                                height: '12px',
                                border: '2px solid #e0e0e0',
                                borderTop: '2px solid #007bff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '6px'
                              }}></div>
                              Loading...
                            </div>
                          </td>
                        )}
                      </tr>
                    )}

                    {/* Doubtful Revenue Row */}
                    {topTableDoubtfulRevenue.length > 0 && (
                      <tr className="table_tr_odd">
                        {topTableDoubtfulRevenue.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}
                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {index === 0 ? (
                                <>
                                  Doubtful Revenue
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span>
                              )}
                            </div>
                          </td>
                        ))}
                        {isColoumLoading && (
                          <td style={{ 
                            minWidth: 120,
                            background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'loading-shimmer 1.5s infinite',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}>
                              <div style={{
                                width: '12px',
                                height: '12px',
                                border: '2px solid #e0e0e0',
                                borderTop: '2px solid #007bff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '6px'
                              }}></div>
                              Loading...
                            </div>
                          </td>
                        )}
                      </tr>
                    )}

                    {/* Total Holdings Row */}
                    {topTableTotalHoldings.length > 0 && (
                      <tr className="table_tr_even">
                        {topTableTotalHoldings.map((item, index) => (
                          <td
                            key={index}
                            className={index === 0 ? 'title_thead_td sticky-col left-col-1' : ''}
                            style={{ textAlign: index === 0 ? 'left' : 'right' }}
                            width={index === 0 ? '280' : '220'}
                          >
                            <div className={index === 0 ? 'head_purification_col1' : ''}>
                              {index === 0 ? (
                                <>
                                  Total Holdings
                                </>
                              ) : (
                                <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span>
                              )}
                            </div>
                          </td>
                        ))}
                        {isColoumLoading && (
                          <td style={{ 
                            minWidth: 120,
                            background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'loading-shimmer 1.5s infinite',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '8px',
                              color: '#666',
                              fontSize: '12px'
                            }}>
                              <div style={{
                                width: '12px',
                                height: '12px',
                                border: '2px solid #e0e0e0',
                                borderTop: '2px solid #007bff',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '6px'
                              }}></div>
                              Loading...
                            </div>
                          </td>
                        )}
                      </tr>
                    )}

                  </tbody>
                </table>

              </div>
            </div>
          </div>

          <button className="btn_eft_toggle" onClick={toggleContent}>
            <img src={IconEFTToggle} />
          </button>
        </div>
        <ul className="purification_tab_menu mb-3">
          <li
            className={activeTab === 'SharesETF' ? 'active' : ''}
            onClick={() => {
              setActiveTab('SharesETF');
              setExpandedRowId(null);
            }}
          >
            Shares in ETF
          </li>
          <li
            className={activeTab === 'PurificationAmount' ? 'active' : ''}
            onClick={() => {
              setActiveTab('PurificationAmount');
              setExpandedRowId(null);
            }}
          >
            Purification Amount
          </li>
        </ul>
        <div className="tab_content">
          {activeTab === 'SharesETF' && (

            <>
              {isLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}
              {/* Table */}
              {!isLoading && (
                <div className='company_table_list etf_holding_table clsPurification' data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
                  <div className='table-responsive' ref={bottomRef} onScroll={() => handleTableScroll("bottom")}  >
                    <table className='table table_fixed_column' >
                      <thead>
                        <tr>
                          {tableHeader.length > 0 &&
                            tableHeader.map((item, index) => (
                              <>
                                <th className={index === 0 ? 'sticky-col left-col-1' : index === 1 ? 'sticky-col left-col-2' : ''} style={{ textAlign: index === 0 ? 'center' : index === 1 ? 'left' : 'right', width: index === 0 ? '10%' : index === 1 ? '16%' : 'auto' }} width="180">{item}</th>
                              </>

                            ))}
                          {isColoumLoading && (
                            <th style={{ 
                              minWidth: 120, 
                              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                              backgroundSize: '200% 100%',
                              animation: 'loading-shimmer 1.5s infinite',
                              position: 'relative',
                              overflow: 'hidden'
                            }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '8px',
                                color: '#666',
                                fontSize: '12px',
                                fontWeight: '500'
                              }}>
                                <div style={{
                                  width: '16px',
                                  height: '16px',
                                  border: '2px solid #e0e0e0',
                                  borderTop: '2px solid #007bff',
                                  borderRadius: '50%',
                                  animation: 'spin 1s linear infinite',
                                  marginRight: '8px'
                                }}></div>
                                Loading...
                              </div>
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.length > 0 ? (
                          tableData.map((row, index) => (
                            <>
                              <tr className={index % 2 === 0 ? 'table_tr_odd' : 'table_tr_even'} style={{ cursor: 'pointer' }}>
                                {row.share.map((shareValue, i) => (
                                  <>
                                    <td width={180} style={{ textAlign: i === 0 || i === 1 ? 'left' : 'right' }}
                                      className={`accordion-toggle collapsed ${i === 0 ? 'sticky-col left-col-1' : i === 1 ? 'sticky-col left-col-2' : ''}`} onClick={() => handleRowClick(index)}>
                                      {i >= 2 && row.atDate && row.atDate[i] ? (
                                        <Whisper placement="top" controlId={`share-tooltip-${index}-${i}`} trigger="hover" speaker={<Tooltip>Finhubb LUD: {row.atDate[i]}</Tooltip>}>
                                          <span className={`${i === 0 ? 'stock_lable' : ''} ${shareValue === '-' ? 'date_null' : ''} ${i === 0 ? 'purification_col1' : i === 1 ? 'purification_col2' : ''} ${shareValue === 'N/A' ? 'date_na' : shareValue == null ? 'date_null' : ''} `}>
                                            {i === 0 && (shareValue === null || shareValue === '' || shareValue === undefined)
                                              ? ''
                                              : shareValue || 'NULL'}
                                          </span>
                                        </Whisper>
                                      ) : (
                                        <span className={`${i === 0 ? 'stock_lable' : ''} ${shareValue === '-' ? 'date_null' : ''} ${i === 0 ? 'purification_col1' : i === 1 ? 'purification_col2' : ''} ${shareValue === 'N/A' ? 'date_na' : shareValue == null ? 'date_null' : ''} `}>
                                          {i === 0 && (shareValue === null || shareValue === '' || shareValue === undefined)
                                            ? ''
                                            : shareValue || 'NULL'}
                                        </span>
                                      )}
                                    </td>

                                  </>
                                ))}
                                {isColoumLoading && (
                                  <td style={{ 
                                    minWidth: 120,
                                    background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                                    backgroundSize: '200% 100%',
                                    animation: 'loading-shimmer 1.5s infinite',
                                    position: 'relative',
                                    overflow: 'hidden'
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      padding: '8px',
                                      color: '#666',
                                      fontSize: '12px'
                                    }}>
                                      <div style={{
                                        width: '12px',
                                        height: '12px',
                                        border: '2px solid #e0e0e0',
                                        borderTop: '2px solid #007bff',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite',
                                        marginRight: '6px'
                                      }}></div>
                                      Loading...
                                    </div>
                                  </td>
                                )}
                              </tr>



                         <tr className="hiddenRow">
                                <td colspan="32" style={{ padding: 0, position: 'sticky', left: 0 }}>

                                  <div className={`accordian-body collapse ${expandedRowId === index ? 'show' : 'hide'}`} id={`TableRow${index}`}>

 
              
                  <>
                                      {rowHistoryData[index]?.length > 0 ? (
                                        <div className='table_accordion_row'>
                                          <div className='table_accordion_col' style={{ width: '100%' }} >
                                            <div className='etf_details_row pb-2'>
                                              <h4>Company Details</h4>
                                            </div>

                                        {loadingRowId == index  && (
                                            <Placeholder.Grid rows={4} columns={32} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />
                                            )}
                                             {loadingRowId !== index && (
                 
                                            <div className='etf_fieldset_row etf_fieldset_row_new'>
                                              <fieldset className='fieldset_col three_rows_fieldset'>
                                                <legend className='legend_title'>Quarter Purification Amount</legend>

                                                {rowHistoryData[index].map((subitem, i) => (

                                                  <div className='purification_fieldset_row'>
                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Quarter
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.report_quarter}
                                                      </div>
                                                    </div>

                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Year
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.report_year}
                                                      </div>
                                                    </div>

                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Date
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.report_date}
                                                      </div>
                                                    </div>
                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Purif. Amt/Share/Day
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.purification_amt_per_share_day}
                                                      </div>
                                                    </div>
                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Compliance Status
                                                      </div>
                                                      <div  className={`input__group_redis_value ${ subitem.compliance_status == 'CMPT' ? 'IRI_CMPT' : subitem.compliance_status == 'NCMPT' ? 'IRI_NCMPT' : subitem.compliance_status == 'DBFT' ? 'IRI_DBFT' : '' }`}>
                                                        {subitem.compliance_status}
                                                      </div>
                                                    </div>
                                                  </div>

                                                ))}
                                              </fieldset>
                                            </div>
 )}
                                          </div>
                                        </div>
                                      ) : (
                                        <>
                                          <div className='table_accordion_row'>
                                            <div className='table_accordion_col' style={{ width: '100%' }} >
                                              <div className='etf_details_row pb-2'>
                                                <h4>No History Found</h4>
                                              </div>


                                            </div>
                                          </div>

                                        </>
                                      )}
                                      </>

                                  </div>

                                </td>
                              </tr>






                            </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="31" style={{ fontSize: 20, paddingTop: 30, paddingBottom: 30 }}>
                              No data available
                            </td>
                          </tr>
                        )}

                      </tbody>
                      <tfoot className="table-light table-sticky-footer">
                         <tr>
                          {tableFooter3.length > 0 &&
                            tableFooter3.map((item, index) => (
                              <>
                                <td width={180} colSpan={index === 0 ? 2 : 1} style={index !== 0 ? { textAlign: 'right' } : {}} > <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span></td>
                              </>
                            ))}
                        </tr>
                        <tr>
                          {tableFooter1.length > 0 &&
                            tableFooter1.map((item, index) => (
                              <>
                                <td width={180} colSpan={index === 0 ? 2 : 1} style={index !== 0 ? { textAlign: 'right' } : {}}> <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span></td>
                              </>
                            ))}
                        </tr>
                        <tr>
                          {tableFooter2.length > 0 &&
                            tableFooter2.map((item, index) => (
                              <>
                                <td width={180} colSpan={index === 0 ? 2 : 1} style={index !== 0 ? { textAlign: 'right' } : {}} > <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span></td>
                              </>
                            ))}
                        </tr>
                         
                      </tfoot>
                    </table>
                  </div>
                  {reportCount > 0 && renderPagination()}
                </div>
              )}
            </>

          )}
          {activeTab === 'PurificationAmount' && (
            <>
              {isLoading && (<Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />)}
              {/* Table */}
              {!isLoading && (
                <div className='company_table_list etf_holding_table clsPurification' data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
                  <div className='table-responsive' ref={bottomRef} onScroll={() => handleTableScroll("bottom")}>
                    <table className='table table_fixed_column' >
                      <thead>
                        <tr>
                          {tableHeader.length > 0 &&
                            tableHeader.map((item, index) => (
                              <>
                                <th className={index === 0 ? 'sticky-col left-col-1' : index === 1 ? 'sticky-col left-col-2' : ''} style={{ textAlign: index === 0 ? 'center' : index === 1 ? 'left' : 'right', width: index === 0 ? '10%' : index === 1 ? '16%' : 'auto' }} width="180">{item}</th>
                              </>
                            ))}
                          {isColoumLoading && (
                            <th style={{ 
                              minWidth: 120, 
                              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                              backgroundSize: '200% 100%',
                              animation: 'loading-shimmer 1.5s infinite',
                              position: 'relative',
                              overflow: 'hidden'
                            }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '8px',
                                color: '#666',
                                fontSize: '12px',
                                fontWeight: '500'
                              }}>
                                <div style={{
                                  width: '16px',
                                  height: '16px',
                                  border: '2px solid #e0e0e0',
                                  borderTop: '2px solid #007bff',
                                  borderRadius: '50%',
                                  animation: 'spin 1s linear infinite',
                                  marginRight: '8px'
                                }}></div>
                                Loading...
                              </div>
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.length > 0 ? (
                          tableData.map((row, index) => (
                            <>
                              <tr className={index % 2 === 0 ? 'table_tr_odd' : 'table_tr_even'} style={{ cursor: 'pointer' }}>
                                {row.purification_amount_etf.map((shareValue, i) => (
                                  <>
                                    <td width={180} style={{ textAlign: i === 0 || i === 1 ? 'left' : 'right' }} className={`accordion-toggle collapsed ${i === 0 ? 'sticky-col left-col-1' : i === 1 ? 'sticky-col left-col-2' : ''}`} onClick={() => handleRowClick(index)}>
                                      {i >= 2 && row.atDate && row.atDate[i] ? (
                                        <Whisper placement="top" controlId={`purification-tooltip-${index}-${i}`} trigger="hover" speaker={<Tooltip>Finhubb LUD: {row.atDate[i]}</Tooltip>}>
                                          <span className={`${i === 0 ? 'stock_lable' : ''} ${shareValue === '-' ? 'date_null' : ''} ${i === 0 ? 'purification_col1' : i === 1 ? 'purification_col2' : ''} ${shareValue === 'N/A' ? 'date_na' : shareValue === null ? 'date_null' : ''}`}>
                                            {i === 0 && (shareValue === null || shareValue === '' || shareValue === undefined)
                                              ? ''
                                              : shareValue || 'NULL'}
                                          </span>
                                        </Whisper>
                                      ) : (
                                        <span className={`${i === 0 ? 'stock_lable' : ''} ${shareValue === '-' ? 'date_null' : ''} ${i === 0 ? 'purification_col1' : i === 1 ? 'purification_col2' : ''} ${shareValue === 'N/A' ? 'date_na' : shareValue === null ? 'date_null' : ''}`}>
                                          {i === 0 && (shareValue === null || shareValue === '' || shareValue === undefined)
                                            ? ''
                                            : shareValue || 'NULL'}
                                        </span>
                                      )}
                                    </td>
                                  </>
                                ))}
                                {isColoumLoading && (
                                  <td style={{ 
                                    minWidth: 120,
                                    background: 'linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%)',
                                    backgroundSize: '200% 100%',
                                    animation: 'loading-shimmer 1.5s infinite',
                                    position: 'relative',
                                    overflow: 'hidden'
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      padding: '8px',
                                      color: '#666',
                                      fontSize: '12px'
                                    }}>
                                      <div style={{
                                        width: '12px',
                                        height: '12px',
                                        border: '2px solid #e0e0e0',
                                        borderTop: '2px solid #007bff',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite',
                                        marginRight: '6px'
                                      }}></div>
                                      Loading...
                                    </div>
                                  </td>
                                )}
                              </tr>

                              <tr className="hiddenRow">
                                <td colspan="32" style={{ padding: 0, position: 'sticky', left: 0 }}>

                                  {/* <div className={`accordian-body collapse ${expandedRowId === index ? 'show' : 'hide'}`} id={`TableRow${index}`}> */}
                                <div
  className="accordion-body"
  style={{
    maxHeight: expandedRowId === index ? '2000px' : '0px',
    overflow: 'hidden',
    transition: 'max-height 0.2s ease',
  }}
>
                  <>
                                      {rowHistoryData[index]?.length > 0 ? (
                                        <div className='table_accordion_row'>
                                          <div className='table_accordion_col' style={{ width: '100%' }} >
                                            <div className='etf_details_row pb-2'>
                                              <h4>Company Details</h4>
                                            </div>

                                        {loadingRowId == index  && (
                                            <Placeholder.Grid rows={4} columns={32} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} />
                                            )}
                                             {loadingRowId !== index && (
                 
                                            <div className='etf_fieldset_row etf_fieldset_row_new'>
                                              <fieldset className='fieldset_col three_rows_fieldset'>
                                                <legend className='legend_title'>Quarter Purification Amount</legend>

                                                {rowHistoryData[index].map((subitem, i) => (

                                                  <div className='purification_fieldset_row'>
                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Quarter
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.report_quarter}
                                                      </div>
                                                    </div>

                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Year
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.report_year}
                                                      </div>
                                                    </div>

                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Date
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.report_date}
                                                      </div>
                                                    </div>
                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Purif. Amt/Share/Day
                                                      </div>
                                                      <div className='input__group_redis_value'>
                                                        {subitem.purification_amt_per_share_day}
                                                      </div>
                                                    </div>
                                                    <div className='input__group_redis'>
                                                      <div className='input__group_redis_label'>
                                                        Compliance Status
                                                      </div>
                                                      <div  className={`input__group_redis_value ${ subitem.compliance_status == 'CMPT' ? 'IRI_CMPT' : subitem.compliance_status == 'NCMPT' ? 'IRI_NCMPT' : subitem.compliance_status == 'DBFT' ? 'IRI_DBFT' : '' }`}>
                                                        {subitem.compliance_status}
                                                      </div>
                                                    </div>
                                                  </div>

                                                ))}
                                              </fieldset>
                                            </div>
 )}
                                          </div>
                                        </div>
                                      ) : (
                                        <>
                                          <div className='table_accordion_row'>
                                            <div className='table_accordion_col' style={{ width: '100%' }} >
                                              <div className='etf_details_row pb-2'>
                                                <h4>No History Found</h4>
                                              </div>


                                            </div>
                                          </div>

                                        </>
                                      )}
                                      </>

                                  </div>

                                </td>
                              </tr>




                            </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="31" style={{ fontSize: 20, paddingTop: 30, paddingBottom: 30 }}>
                              No data available
                            </td>
                          </tr>
                        )}


                      </tbody>
                      <tfoot className="table-light table-sticky-footer">
                         <tr>
                          {tableFooter3.length > 0 &&
                            tableFooter3.map((item, index) => (
                              <>
                                <td colSpan={index === 0 ? 2 : 1} style={index !== 0 ? { textAlign: 'right' } : {}}> <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span></td>
                              </>
                            ))}
                        </tr>
                        <tr>
                          {tableFooter1.length > 0 &&
                            tableFooter1.map((item, index) => (
                              <>
                                <td colSpan={index === 0 ? 2 : 1} style={index !== 0 ? { textAlign: 'right' } : {}}> <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span></td>
                              </>
                            ))}
                        </tr>
                        <tr>
                          {tableFooter2.length > 0 &&
                            tableFooter2.map((item, index) => (
                              <>
                                <td colSpan={index === 0 ? 2 : 1} style={index !== 0 ? { textAlign: 'right' } : {}}> <span className={item === 'N/A' ? 'date_na' : item == null ? 'date_null' : ''}>{item || 'NULL'}</span></td>
                              </>
                            ))}
                        </tr>
                        
                      </tfoot>
                    </table>
                  </div>
                  {reportCount > 0 && renderPagination()}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div class="modal fade report_delete_modals" id="ModalDelete" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <h5>Are you sure you want to Change?</h5>
              <p>The changes will be applied across all the <br />ETFs within the given market.</p>
              <div class="btn__group mt-5" style={{}}>
                <button type="button" class="btn_cancel" id="CancelConfirmation" data-bs-dismiss="modal" style={{ display: 'none' }}>Cancel</button>
                <Button type="button" className="btn_cancel" onClick={() => handleIRCancel()} style={{ borderColor: '#A1B9ED' }}>Cancel</Button>
                <Button className="btn_delete" onClick={() => handleCalculateIRConfirm()} loading={calculateIRLoading}>Save</Button>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="modal fade report_delete_modals" id="ModalUpdateAUM1" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true" data-bs-backdrop="static" >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <h5>Are you sure you want to calculate the <br /> data based on your selection?</h5>
              {/* <p>This action cannot be reversed. To revert or go back to the <br/>
                                        default selection, click on "Reverse AUM Values"</p> */}
              <p></p>
              <div class="btn__group mt-5" style={{}}>

                <button type="button" class="btn_cancel" id="CancelUnitConfirmation" data-bs-dismiss="modal" style={{ display: 'none' }}>Cancel</button>
                <Button type="button" className="btn_cancel" onClick={() => handleUnitsCancel()} style={{ borderColor: '#A1B9ED' }}>Cancel</Button>
                <Button className="btn_delete" onClick={() => handleCalculateUnitConfirm()} loading={calculateUnitLoading}>Save</Button>

              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="modal fade report_delete_modals" id="ModalUpdateAUM2" tabindex="-1" aria-labelledby="AddNewAnalystModalLabel" aria-hidden="true" data-bs-backdrop="static" >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <h5>Are you sure you want to reset the <br /> data based on your selection?</h5>
              {/* <p>This action cannot be reversed. To revert or go back to the <br/>
                                        default selection, click on "Reverse AUM Values"</p> */}
              <p></p>
              <div class="btn__group mt-5" style={{}}>

                <button type="button" class="btn_cancel" id="CancelUnitConfirmation1" data-bs-dismiss="modal" style={{ display: 'none' }}>Cancel</button>
                <Button type="button" className="btn_cancel" onClick={() => handleUnitsCancel1()} style={{ borderColor: '#A1B9ED' }}>Cancel</Button>
                <Button className="btn_delete" onClick={() => handleCalculateUnitConfirm1()} loading={calculateUnitLoading1}>Save</Button>

              </div>

            </div>

          </div>
        </div>
      </div>

      <ChakraProvider resetCSS={false} >  </ChakraProvider>

    </>
  );
}

export default ETFHolding;
